/**
 * @generated SignedSource<<423ff891cf06ede09fa88198c14471e8>>
 * @relayHash 19fc85c74f8d6d3a90115f31d4c49e6f
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 19fc85c74f8d6d3a90115f31d4c49e6f

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FileUploadRequestType = "AFFECTED_AREA_NOT_VISIBLE" | "DOCUMENT_REQUIRED" | "INSUFFICIENT_QUALITY_OF_PHOTOS" | "PHOTOS_REQUIRED";
export type CreateFileUploadRequestInput = {
  appointmentId: string;
  requestDocumentType: FileUploadRequestType;
};
export type useFileUploadRequestMutation$variables = {
  input: CreateFileUploadRequestInput;
};
export type useFileUploadRequestMutation$data = {
  readonly createFileUploadRequest: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly fileUploadRequest: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"FileUploadRequestFragment">;
    } | null;
  };
};
export type useFileUploadRequestMutation = {
  response: useFileUploadRequestMutation$data;
  variables: useFileUploadRequestMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useFileUploadRequestMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CreateFileUploadRequestPayload",
        "kind": "LinkedField",
        "name": "createFileUploadRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FileUploadRequest",
            "kind": "LinkedField",
            "name": "fileUploadRequest",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FileUploadRequestFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useFileUploadRequestMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CreateFileUploadRequestPayload",
        "kind": "LinkedField",
        "name": "createFileUploadRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FileUploadRequest",
            "kind": "LinkedField",
            "name": "fileUploadRequest",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sessionCode",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "19fc85c74f8d6d3a90115f31d4c49e6f",
    "metadata": {},
    "name": "useFileUploadRequestMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7267d2f15db79ffc398c020d698c205d";

export default node;
